import React, { useMemo } from 'react'
import { BUILD_STAGES } from './experienceNavigation'

const itemStatusClass = (meta, itemKey) => {
  if (meta.pending) return ' empty'
  const state = meta.itemState && meta.itemState[itemKey]
  if (state === 'empty') return ' empty'
  if (state === 'partial') return ' miss'
  if (state === 'done') return ''
  if (meta.itemIssues && meta.itemIssues[itemKey]) return ' miss'
  return ''
}

const ExperienceBuildRail = ({
  activeStageKey,
  activeItemKey,
  onStageToggle,
  onSelectItem,
  stageMeta = {},
  disabled = false,
}) => {
  const stages = useMemo(() => BUILD_STAGES, [])
  const anyPending = stages.some((stage) => stageMeta[stage.key]?.pending)

  return (
    <aside
      className={`experience-rail${disabled ? ' is-disabled' : ''}`}
      aria-disabled={disabled}>
      <div className='experience-rail-label'>Build experience</div>
      {stages.map((stage, stageIndex) => {
        const meta = stageMeta[stage.key] || {}
        const isOpen = activeStageKey === stage.key
        const isDone = !!meta.done && !meta.pending
        const countLabel =
          meta.countLabel || `${stage.items.length} of ${stage.items.length}`

        return (
          <div
            key={stage.key}
            className={`experience-stage${isDone ? ' done' : ''}${
              isOpen ? ' open' : ''
            }${meta.pending ? ' pending' : ''}`}>
            <button
              type='button'
              className='experience-shead'
              disabled={disabled}
              onClick={() => onStageToggle(stage.key)}>
              <span className='experience-idx'>
                {isDone ? '✓' : stageIndex + 1}
              </span>
              <b>{stage.label}</b>
              <span className='experience-count'>{countLabel}</span>
            </button>
            <div className='experience-sbody'>
              {stage.items.map((item) => (
                <button
                  key={item.key}
                  type='button'
                  className={`experience-rail-item${
                    activeItemKey === item.key ? ' sel' : ''
                  }`}
                  disabled={disabled}
                  onClick={() => onSelectItem(item.key)}>
                  <i
                    className={`experience-st${itemStatusClass(
                      meta,
                      item.key,
                    )}`}
                  />
                  {item.label}
                  {!meta.pending &&
                  meta.itemNotes &&
                  meta.itemNotes[item.key] ? (
                    <span className='experience-note'>
                      {meta.itemNotes[item.key]}
                    </span>
                  ) : null}
                </button>
              ))}
              {stage.optionalLabel && stage.optionalItems?.length ? (
                <>
                  <div className='experience-optdiv'>
                    <span>{stage.optionalLabel}</span>
                  </div>
                  {stage.optionalItems.map((item) => (
                    <button
                      key={item.key}
                      type='button'
                      className={`experience-rail-item${
                        activeItemKey === item.key ? ' sel' : ''
                      }`}
                      disabled={disabled}
                      onClick={() => onSelectItem(item.key)}>
                      <i
                        className={`experience-st${itemStatusClass(
                          meta,
                          item.key,
                        )}`}
                      />
                      {item.label}
                    </button>
                  ))}
                </>
              ) : null}
            </div>
          </div>
        )
      })}
      <div className='experience-legend'>
        {anyPending ? (
          <div>
            <i className='experience-st empty' /> Checking…
          </div>
        ) : null}
        <div>
          <i className='experience-st' /> Complete
        </div>
        <div>
          <i className='experience-st miss' /> Needs attention
        </div>
      </div>
    </aside>
  )
}

export default ExperienceBuildRail
